export function useCookies() {
  const cookieState = useCookieSate();
  const isClient = ref(false);

  onMounted(() => {
    isClient.value = true;
  });

  return {
    showCookiesModal: computed(() => isClient.value && cookieState.cookiesAccepted === 'pending'),
    setCookies: (categories: string[]) => cookieState.acceptCookies(categories),
  };
}
